import { render, staticRenderFns } from "./QuickSummary.vue?vue&type=template&id=0a52f5b0&"
import script from "./QuickSummary.vue?vue&type=script&lang=js&"
export * from "./QuickSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports